import React, { memo } from 'react';
import PropTypes from 'prop-types';

import PageContent from 'components/PageContent';
import CurrencyYearArchiveSourceSection from 'components/CurrencyYearArchiveSourceSection';
import CurrencyYearArchiveSourceTabs from 'components/CurrencyYearArchiveSourceTabs';
import { CURRENCY_YEAR_ARCHIVE_SOURCE } from 'constants/currencyYearArchive';

const CurrencyYearArchivePageContent = ({
  children,
  sources,
  year,
  currencyLabel,
  highlightedDate,
  activeSource,
  onSourceSelect,
  isArchiveLoading,
}) => (
  <PageContent>
    {children}
    <CurrencyYearArchiveSourceTabs
      activeSource={activeSource}
      onSourceSelect={onSourceSelect}
    />
    {Object.values(CURRENCY_YEAR_ARCHIVE_SOURCE).map(optionType => (
      <CurrencyYearArchiveSourceSection
        key={optionType}
        optionType={optionType}
        source={sources?.[optionType]}
        year={year}
        currencyLabel={currencyLabel}
        highlightedDate={highlightedDate}
        isArchiveLoading={isArchiveLoading}
      />
    ))}
  </PageContent>
);

CurrencyYearArchivePageContent.propTypes = {
  children: PropTypes.node,
  sources: PropTypes.shape({
    [CURRENCY_YEAR_ARCHIVE_SOURCE.cash]: PropTypes.object,
    [CURRENCY_YEAR_ARCHIVE_SOURCE.nbu]: PropTypes.object,
    [CURRENCY_YEAR_ARCHIVE_SOURCE.interbank]: PropTypes.object,
    [CURRENCY_YEAR_ARCHIVE_SOURCE.banks]: PropTypes.object,
    [CURRENCY_YEAR_ARCHIVE_SOURCE.cards]: PropTypes.object,
  }),
  year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  currencyLabel: PropTypes.string.isRequired,
  highlightedDate: PropTypes.string,
  activeSource: PropTypes.string.isRequired,
  onSourceSelect: PropTypes.func.isRequired,
  isArchiveLoading: PropTypes.bool,
};

CurrencyYearArchivePageContent.defaultProps = {
  children: null,
  sources: null,
  highlightedDate: null,
  isArchiveLoading: false,
};

export default memo(CurrencyYearArchivePageContent);
